import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import {
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import useLogs from "hooks/logs";
import { useWebsocketFetch } from "hooks/useWebsocketFetch";
import { useVisionLogin } from "hooks/useVisionLogin";

import TableSolicitacaoDevolucao from "../components/table-solicitacao-devolucao";
import TableSolicitacaoDevolucaoNota from "../components/table-solicitacao-devolucao-nota";
import ChooseProductDialog from "../components/choose-product-dialog";
import ChooseInvoiceDialog from "../components/choose-invoice-dialog";
import ClearButton from "components/_refactor/button/clear";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import NotFound from "components/Texts/NotFound";
import FormSolicitarDevolucaoDialog from "../components/form-dialog";

import { API_ENV } from "constants/environment";
import { IsSmall, IsMobile, IsMobile900 } from "utils/is-mobile";

const RETURN_TYPES = [
  { name: "Devolução por código/descrição do produto", value: "1" },
  { name: "Devolução por nota fiscal", value: "2" },
];

const MAX_IMAGES = 4;
const MAX_IMAGE_SIZE = 1024 * 1024; // 1MB

const useStyles = makeStyles({
  imagePreview: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
  },
  imageContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    margin: "8px 0",
    padding: "10px 0",
  },
  imageWrapper: {
    position: "relative",
    width: "80px",
    height: "80px",
  },
  removeImageButton: {
    position: "absolute",
    top: -14,
    right: -14,
    padding: "4px 7px",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  hiddenInput: {
    display: "none",
  },
});

export default function SolicitarDevolucaoStep1({
  groupName,
  setGroupName,
  socialName,
  setSocialName,
  cnpj,
  setCnpj,
  plataformList,
  plataform,
  setPlataform,
  selectedReason,
  setSelectedReason,
  selectedReasonComplete,
  setSelectedReasonComplete,
  selectedDefect,
  setSelectedDefect,
  selectedDefectComplete,
  setSelectedDefectComplete,
  isLoading,
  setIsLoading,
  solicitacao,
  setSolicitacao,
  setStep,
  item,
  setItem,
}) {
  const [groupNameList, setGroupNameList] = useState([]);
  const [loadingGroupName, setLoadingGroupName] = useState(false);
  const [socialNameList, setSocialNameList] = useState([]);
  const [loadingSocialName, setLoadingSocialName] = useState(false);
  const [reasonsList, setReasonsList] = useState([]);
  const [defectList, setDefectList] = useState([]);
  const [defectByReason, setDefectByReason] = useState([]);

  const [showCNPJNotFound, setShowCNPJNotFound] = useState(false);
  const [searchReason, setSearchReason] = useState(false);
  const [searchDefect, setSearchDefect] = useState(false);

  const [product, setProduct] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [isValidProduct, setIsValidProduct] = useState();
  const [isProductAlreadySelected, setIsProductAlreadySelected] =
    useState(false);
  const [quantity, setQuantity] = useState("");
  const [choosedProduct, setChoosedProduct] = useState();
  const [selectedProduct, setSelectedProduct] = useState();
  const [addedProductsList, setAddedProductsList] = useState(item || []);
  const [productImages, setProductImages] = useState([]);

  const [invoice, setInvoice] = useState("");
  const [invoiceSelected, setInvoiceSelected] = useState([]);
  const [isInvoiceValid, setIsInvoiceValid] = useState();
  const [isInvoiceAlreadySelected, setIsInvoiceAlreadySelected] =
    useState(false);
  const [selectedProductsList, setSelectedProductsList] = useState([]);

  const [returnType, setReturnType] = useState("1");
  const [toggleFormDialog, setToggleFormDialog] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const fileInputRef = useRef(null);
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();
  const { userId } = useVisionLogin();
  const classes = useStyles();
  const snackbar = useSnackbar();

  const isMobile = IsMobile();
  const isMobile900 = IsMobile900();
  const isMobile1200 = IsSmall();

  const itemXS9 = useMemo(() => (isMobile ? 12 : 9), [isMobile]);
  const itemXS6 = useMemo(() => (isMobile ? 12 : 6), [isMobile]);
  const itemXSResponsive = isMobile
    ? 12
    : isMobile900
    ? 6
    : isMobile1200
    ? 4
    : 3;

  const { handleFetchData, status, handleFetchUrl } = useWebsocketFetch({
    onSuccess: (data) => {
      const invoice = {
        NumeroNf: data[0]?.NumeroNf || null,
        ValorTotal: data[0]?.ValorTotal || null,
        SerieNf: data[0]?.SerieNf || null,
        DataEmissaoNf: data[0]?.DataEmissaoNf || null,
        items: data[0]?.ListaProdutosExport.map((item) => ({
          Selected: false,
          IdPedido: data[0]?.IdPedido || null,
          idProduto: item.Codigo || null,
          name: item.Descricao || null,
          QtdFaturada: item.QtdFaturada || null,
          QuantidadeDevolvida: item.QuantidadeDevolvida || 0,
          ValorUnitario: item.ValorUnitario || null,
          ValorTotal:
            (item.QtdFaturada * item.ValorUnitario).toFixed(2) || null,
          quantidade: item.QtdFaturada - item.QuantidadeDevolvida || null,
          idMotivo: undefined,
          motivo: undefined,
          idDefeito: undefined,
          defeito: undefined,
        })),
      };
      setInvoiceSelected(invoice);
      handleGetReasons();
      handleGetDefects();
      setIsInvoiceValid(true);
      setOpenDialog(true);
    },
    onError: (error) => {
      snackbar.showMessage(error, {
        severity: "error",
      });
      setIsInvoiceValid(false);
      setLocalStorageApiProblem({
        idMenuAccess: "10",
        screen: "Solicitar Devolução",
        problem: `Erro na chamada do endpoint list-reception-invoices - ${error}`,
      });
    },
  });

  const handleGetEconomicGroupList = async () => {
    setLoadingGroupName(true);
    await Api.get(`econnomical-group`, "commercialstructure", "", true)
      .then((res) => {
        setGroupNameList(res.Result);
        localStorage.setItem(
          "visao360EconomicGroupList",
          JSON.stringify(res.Result)
        );

        if (res.Result.length === 1) {
          setGroupName(res.Result[0].Id);
        }
      })
      .catch((e) => {
        console.log(e);
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Solicitar Devolução",
          problem: `Erro na chamada do endpoint econnomical-group - ${e}`,
        });
      });
    setLoadingGroupName(false);
  };

  const handleGetSocialNameList = async (page = 0) => {
    if (!groupName) {
      return;
    }
    setLoadingSocialName(true);
    await Api.get(
      "store-user",
      "commercialstructure",
      `?page=${page}&pageSize=1000` +
        (groupName ? `&idGrupoEconomico=${groupName.Id}` : ""),
      true
    )
      .then((res) => {
        if (page === 0) {
          setSocialNameList(res.Result.ListLojas);
        } else {
          setSocialNameList((s) => [...s, ...res.Result.ListLojas]);
        }

        setLoadingSocialName(false);

        if (res.Result.TotalDePaginas > page) {
          handleGetSocialNameList(page + 1);
        }
      })
      .catch((e) => {
        setLoadingSocialName(false);
        console.log(e);
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Solcitar Devolução",
          problem: `Erro na chamada do endpoint store - ${e}`,
        });
      });
  };

  const handleSearchProduct = async () => {
    setIsLoading(true);

    await Api.get(
      "product-simple-list",
      "product",
      "?page=" +
        (page === 0 ? page : page - 1) +
        "&pageSize=25&order=D&filter=" +
        product +
        "&idPessoaLoja=" +
        socialName.Id +
        "&devolucao=true",
      true
    )
      .then((res) => {
        if (res.Result.TotalRegistros > 1) {
          const pages = Math.ceil(res.Result.TotalRegistros / 25);
          setTotalPages(pages);
          setProductsList(res.Result.ListaProdutos);
          setOpenDialog(true);
        }

        if (res.Result.TotalRegistros === 1) {
          setChoosedProduct(res.Result.ListaProdutos[0]);
          setIsValidProduct(true);
          handleGetReasons();
          handleGetDefects();
        }

        if (res.Result.TotalRegistros === 0) {
          setIsValidProduct(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "191",
          screen: "Motivos de Devolucoes",
          problem: `Erro na chamada do endpoint list-reasons - ${error}`,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSearchInvoice = useCallback(async () => {
    if (selectedProductsList.some((product) => product.NumeroNf === invoice)) {
      setIsInvoiceAlreadySelected(true);
      return;
    }
    handleFetchData({
      action: "list-reception-invoices",
      params: {
        querystring: {
          simples: "true",
          idLoja: socialName.Id?.toString(),
          idNF: invoice?.toString(),
        },
        header: {
          "K-IdUser": userId,
        },
      },
    });
  });

  const handleGetReasons = async () => {
    setSearchReason(true);
    await Api.get("list-reason", "trocasDevolucoes", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setReasonsList(Result.ListaMotivos);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "191",
          screen: "Motivos de Devolucoes",
          problem: `Erro na chamada do endpoint list-reasons - ${error}`,
        });
      })
      .finally(() => setSearchReason(false));
  };

  const handleGetDefects = async () => {
    setSearchDefect(true);
    await Api.get("list-defect", "trocasDevolucoes", "?page=0", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setDefectList(Result.ListaDefeitos);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "191",
          screen: "Motivos de Defeitos",
          problem: `Erro na chamada do endpoint list-defect - ${error}`,
        });
      })
      .finally(() => setSearchDefect(false));
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    if (productImages?.length + files.length > MAX_IMAGES) {
      snackbar.showMessage(`Máximo de ${MAX_IMAGES} imagens permitido`, {
        severity: "error",
      });
      return;
    }

    files.forEach((file) => {
      if (file.size > MAX_IMAGE_SIZE) {
        snackbar.showMessage(`Tamanho máximo de imagem permitido é 1MB`, {
          severity: "error",
        });
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setProductImages((prev) => [
          ...prev,
          {
            base64: reader.result,
            name: file.name,
            extension: file.name.split(".").pop().toLowerCase(),
          },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveImage = (index) => {
    setProductImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddProduct = () => {
    console.log("chegou aqui na add product function");
    if (!choosedProduct || !quantity || !selectedReason) return;

    setAddedProductsList([
      ...addedProductsList,
      {
        idTableProduct: addedProductsList?.length + 1,
        idProduto: choosedProduct.Codigo,
        name: choosedProduct.Nome,
        quantidade: quantity,
        idMotivo: selectedReason,
        motivo: selectedReasonComplete?.Motivo,
        idDefeito: selectedDefect || null,
        defeito: selectedDefectComplete?.Defeito || null,
        images: productImages,
      },
    ]);
    console.log("passou daqui");

    resetProductForm();
  };

  const resetProductForm = () => {
    setProduct("");
    setChoosedProduct(null);
    setQuantity("");
    setSelectedReason(null);
    setSelectedDefect(null);
    setDefectByReason(null);
    setIsValidProduct(undefined);
    setProductImages([]);
  };

  const prepareProductsData = () => {
    if (returnType === "1") {
      return addedProductsList.map((product) => ({
        idProduto: product.idProduto,
        name: product.name,
        quantidade: Number(product.quantidade),
        idMotivo: product.idMotivo,
        motivo: product.motivo,
        idDefeito: product.idDefeito || undefined,
        defeito: product.defeito || undefined,
      }));
    } else {
      return selectedProductsList.flatMap((invoice) =>
        invoice.items.map((item) => ({
          idProduto: item.idProduto,
          name: item.name,
          quantidade: Number(item.quantidade),
          idMotivo: item.idMotivo,
          motivo: item.motivo || undefined,
          idDefeito: item.idDefeito || undefined,
          defeito: item.defeito || undefined,
        }))
      );
    }
  };

  const prepareImagesData = () => {
    if (returnType === "1") {
      return addedProductsList.map((product) => ({
        idProduto: product.idProduto,
        images: product.images || [],
      }));
    } else {
      return selectedProductsList.flatMap((invoice) =>
        invoice.items.map((item) => ({
          idProduto: item.idProduto,
          images: item.images || [],
        }))
      );
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const products = prepareProductsData();
      const productImages = prepareImagesData();

      setItem(products);

      if (solicitacao) {
        await updateExistingRequest(products, productImages);
      } else {
        await createNewRequest(products, productImages);
      }
    } catch (error) {
      snackbar.showMessage(error, { severity: "error" });
      setLocalStorageApiProblem({
        idMenuAccess: "10",
        screen: "Solicitar Devolução",
        problem: `Erro ao enviar solicitação - ${error}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const updateExistingRequest = async (products, productImages) => {
    const res = await Api.put(
      "edit-request-reason",
      "trocasDevolucoes",
      {
        idSolicitacao: solicitacao.Id,
        idPessoaLoja: socialName.Id,
        idGrupoEconomico: groupName.Id,
        idMarca: plataform.id,
        itens: products,
        emailEnvio: solicitacao.emailEnvio || "",
      },
      true
    );

    if (res.Success) {
      await processImages(solicitacao.Id, productImages);
      setSolicitacao(res.Result);
      setStep(2);
    }
  };

  const createNewRequest = async (products, productImages) => {
    const res = await Api.post(
      "create-request-reason",
      "trocasDevolucoes",
      {
        idPessoaLoja: socialName.Id,
        idGrupoEconomico: groupName.Id,
        idMarca: plataform.id,
        itens: products,
      },
      true
    );

    if (res.Success) {
      await processImages(res.Result.Id, productImages);
      setSolicitacao(res.Result);
      setStep(2);
    }
  };

  const processImages = async (solicitacaoId, productImages) => {
    try {
      const solicitacaoResponse = await Api.get(
        "list-request-reason",
        "trocasDevolucoes",
        `?page=0&idSolicitacao=${solicitacaoId}`,
        true
      );

      if (solicitacaoResponse.Result.ListSolicitacao.length > 0) {
        const solicitationItems =
          solicitacaoResponse.Result.ListSolicitacao[0].ListSolicitacaoItens;

        for (const productImage of productImages) {
          if (productImage.images?.length > 0) {
            const solicitationItem = solicitationItems.find(
              (item) => item.IdProduto === productImage.idProduto
            );

            if (solicitationItem) {
              for (const image of productImage.images) {
                await Api.post(
                  "update-request-images-item",
                  "trocasDevolucoes",
                  {
                    base64: image.base64.split(",")[1],
                    idSolicitacaoItem: solicitationItem.IdSolicitacaItem,
                    nomeArquivo: image.name,
                    extensao: image.extension,
                  },
                  true
                );
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Erro ao processar imagens:", error);
      snackbar.showMessage(error, { severity: "error" });
    }
  };

  const handleClearFilters = () => {
    if (returnType === "1") {
      resetProductForm();
      setGroupName(null);
      setSocialName("");
      setCnpj("");
      setPlataform(plataformList[0].plataform);
      setShowCNPJNotFound(false);
      setReturnType("1");
      setAddedProductsList([]);
      selectedProduct(null);
      setToggleFormDialog(null);
      setOpenDialog(false);
    }
  };

  useEffect(() => {
    handleFetchUrl(
      `wss://3zvsu3yj2b.execute-api.us-east-1.amazonaws.com/${API_ENV}`
    );
  }, []);

  useEffect(() => {
    if (returnType === "1") {
      return;
    }

    if (status === "fetching") {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }

    if (status === "empty") {
      setIsInvoiceValid(false);
    }
  }, [status]);

  useEffect(() => {
    if (addedProductsList.some((p) => p.Produto === product.toString())) {
      setIsProductAlreadySelected(true);
      setIsLoading(false);
      return;
    }
  }, [product]);

  useEffect(() => {
    setIsLoading(true);
    if (reasonsList.length > 0 && selectedReason) {
      const matchingReason = reasonsList.find(
        (reason) => reason.IdMotivo === selectedReason
      );
      if (matchingReason) {
        setSelectedReasonComplete(matchingReason);
      }
    }
    setIsLoading(false);
  }, [reasonsList, selectedReason]);

  useEffect(() => {
    handleGetEconomicGroupList();
  }, []);

  useEffect(() => {
    handleGetSocialNameList();
  }, [groupName]);

  useEffect(() => {
    const defectByReason = defectList.filter(
      (defect) => defect.IdMotivo === selectedReason
    );
    setDefectByReason(defectByReason);
    setSelectedDefect("");
    setSelectedDefectComplete("");
  }, [selectedReason]);

  useEffect(() => {
    if (choosedProduct) {
      setProduct(`${choosedProduct.Codigo} - ${choosedProduct.Nome}`);
      setIsValidProduct(true);
      handleGetReasons();
      handleGetDefects();
    }
  }, [choosedProduct]);

  useEffect(() => {
    if (page > 0) {
      handleSearchProduct();
    }
  }, [page]);

  useEffect(() => {
    returnType === "1" && setInvoiceSelected([]);
    returnType === "2" && setAddedProductsList([]);
  }, [returnType]);

  useEffect(() => {
    if (returnType === "2") return;
    setAddedProductsList(item);
  }, [item]);

  return (
    <div>
      <Container style={{ marginTop: "-4rem" }} maxWidth={true}>
        <Grid container>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={itemXSResponsive}>
                    <AutoCompleteField
                      label="Nome do Grupo"
                      onChange={setGroupName}
                      options={groupNameList}
                      disabled={groupNameList.length === 1}
                      loading={loadingGroupName}
                      value={
                        groupName ??
                        groupNameList?.length === 1 ??
                        groupNameList[0]
                      }
                    />
                  </Grid>

                  <Grid item xs={itemXS6}>
                    <AutoCompleteField
                      label="Razão Social / Loja"
                      onChange={(value) => {
                        if (value === "all") {
                          setCnpj("");
                          setSocialName("");
                        } else {
                          setCnpj(MaskAndValid.maskCNPJ(value.CNPJ));
                          setSocialName(value);
                        }
                      }}
                      options={socialNameList}
                      disabled={loadingSocialName}
                      loading={loadingGroupName || loadingSocialName}
                      value={
                        (socialName?.length === 1 && socialNameList[0]) ??
                        socialName
                      }
                    />
                  </Grid>

                  <Grid item xs={itemXSResponsive}>
                    <FormGroup data-tut="reactour__step3">
                      <FormLabel>CNPJ</FormLabel>
                      <OutlinedInput
                        fullWidth
                        type="text"
                        placeholder="00.000.000/0000-00"
                        value={cnpj}
                        onChange={(e) => {
                          setCnpj(MaskAndValid.maskCNPJ(e.target.value));
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 18);
                        }}
                        disabled={loadingSocialName || loadingGroupName}
                      />
                    </FormGroup>
                  </Grid>

                  <Grid item xs={itemXSResponsive}>
                    <FormGroup data-tut="reactour__step4">
                      <AutoCompleteField
                        label="Plataforma"
                        onChange={(value) => {
                          setPlataform(value);
                        }}
                        value={plataform}
                        options={plataformList}
                        disabled={loadingSocialName || loadingGroupName}
                        optionLabelKey="plataform"
                        optionIdKey="id"
                      />
                    </FormGroup>
                  </Grid>

                  <Grid item sx={itemXS9} style={{ marginTop: "1.25rem" }}>
                    <FormGroup>
                      <RadioGroup
                        aria-label="opções de pesquisa"
                        required
                        name="type"
                        value={returnType}
                        disabled={loadingSocialName || loadingGroupName}
                        style={{
                          display: "flex",
                          margin: "0",
                          flexDirection: isMobile ? "column" : "row",
                        }}
                        onChange={(e) => {
                          setReturnType(e.target.value);
                        }}
                      >
                        {RETURN_TYPES.map((type) => {
                          return (
                            <FormControlLabel
                              disabled={loadingSocialName || loadingGroupName}
                              key={type?.value}
                              value={type?.value}
                              checked={returnType === type?.value}
                              control={<Radio color="primary" />}
                              label={type.name}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormGroup>
                  </Grid>
                </Grid>

                {groupName && socialName && plataform && (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    </Grid>

                    {returnType === "1" && (
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <FormGroup>
                              <FormLabel>Produto(s)</FormLabel>
                              <TextField
                                name="produto"
                                fullWidth
                                disabled={loadingSocialName || loadingGroupName}
                                value={product}
                                variant="outlined"
                                onChange={(e) => {
                                  setProduct(e.target.value);
                                  setIsValidProduct(undefined);
                                  setIsProductAlreadySelected(false);
                                }}
                                onInput={(e) => {
                                  e.target.value = e.target.value
                                    .toString()
                                    .slice(0, 200);
                                }}
                              />
                            </FormGroup>
                          </Grid>

                          <Button
                            style={{
                              width: isMobile ? "100%" : "17vw",
                              marginBottom: isMobile ? "0.75rem" : "0px",
                              marginTop: isMobile ? "0.75rem" : "20px",
                              height: "end",
                              alignSelf: "center",
                            }}
                            variant="contained"
                            onClick={(e) => {
                              handleSearchProduct();
                            }}
                            disabled={
                              !product ||
                              loadingGroupName ||
                              loadingSocialName ||
                              choosedProduct ||
                              isLoading
                            }
                          >
                            {isLoading ? "Pesquisando..." : "Pesquisar"}
                          </Button>
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={isMobile ? 12 : 4}
                            hidden={!product || !isValidProduct}
                          >
                            <FormGroup>
                              <FormLabel>Quantidade</FormLabel>
                              <OutlinedInput
                                fullWidth
                                disabled={!isValidProduct}
                                type="number"
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                                inputProps={{ min: 1 }}
                              />
                            </FormGroup>
                          </Grid>

                          <Grid
                            item
                            xs={isMobile ? 12 : 4}
                            hidden={!product || !isValidProduct}
                          >
                            <AutoCompleteField
                              label="Motivo de Devolução"
                              onChange={(value) => {
                                setSelectedReason(value.IdMotivo);
                                setSelectedReasonComplete(value);
                                setDefectByReason([]);
                              }}
                              loading={searchReason}
                              value={selectedReasonComplete}
                              options={reasonsList}
                              optionLabelKey="Motivo"
                              optionIdKey="IdMotivo"
                            />
                          </Grid>

                          {defectByReason?.length > 0 && (
                            <Grid
                              item
                              xs={isMobile ? 12 : 4}
                              hidden={!product || !isValidProduct}
                            >
                              <AutoCompleteField
                                label="Motivo de Defeito"
                                loading={searchDefect}
                                onChange={(value) => {
                                  setSelectedDefect(value.IdDefeito);
                                  setSelectedDefectComplete(value);
                                }}
                                value={selectedDefectComplete}
                                options={defectByReason}
                                optionLabelKey="Defeito"
                                optionIdKey="IdDefeito"
                              />
                            </Grid>
                          )}

                          <Grid
                            item
                            xs={12}
                            hidden={!product || !isValidProduct}
                          >
                            <FormGroup>
                              <FormLabel>
                                Imagens do Produto (máximo 4)
                              </FormLabel>
                              <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleImageUpload}
                                ref={fileInputRef}
                                className={classes.hiddenInput}
                                disabled={!isValidProduct}
                              />
                              <div className={classes.imageContainer}>
                                {productImages.map((image, index) => (
                                  <div
                                    key={index}
                                    className={classes.imageWrapper}
                                  >
                                    <img
                                      src={image.base64}
                                      alt={`Preview ${index + 1}`}
                                      className={classes.imagePreview}
                                    />
                                    <IconButton
                                      size="small"
                                      className={classes.removeImageButton}
                                      onClick={() => handleRemoveImage(index)}
                                    >
                                      <i className="fas fa-times" />
                                    </IconButton>
                                  </div>
                                ))}
                              </div>
                              <Button
                                style={{
                                  width: isMobile ? "100%" : "20vw",
                                  marginBottom: isMobile ? "0.75rem" : "0rem",
                                  marginTop: isMobile ? "0.75rem" : "0",
                                }}
                                variant="contained"
                                onClick={() => fileInputRef.current?.click()}
                                disabled={productImages?.length >= 4}
                              >
                                Adicionar Imagens
                              </Button>
                            </FormGroup>
                          </Grid>
                        </Grid>

                        <Divider
                          variant="fullWidth"
                          style={{ margin: "20px 0px" }}
                        />
                      </>
                    )}

                    {returnType === "2" && (
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <FormGroup>
                              <FormLabel>Nota Fiscal</FormLabel>
                              <TextField
                                name="notaFiscal"
                                fullWidth
                                disabled={loadingSocialName || loadingGroupName}
                                value={invoice}
                                variant="outlined"
                                onChange={(e) => {
                                  setInvoice(e.target.value);
                                  setIsInvoiceValid(true);
                                  setIsInvoiceAlreadySelected(false);
                                }}
                                onInput={(e) => {
                                  e.target.value = e.target.value
                                    .toString()
                                    .replace(/\D/g, "")
                                    .slice(0, 10);
                                }}
                              />
                            </FormGroup>
                          </Grid>

                          <Button
                            style={{
                              width: isMobile ? "100%" : "17vw",
                              marginBottom: isMobile ? "0.75rem" : "0px",
                              marginTop: isMobile ? "0.75rem" : "20px",
                              height: "end",
                              alignSelf: "center",
                            }}
                            variant="contained"
                            onClick={(e) => {
                              handleSearchInvoice();
                            }}
                            disabled={
                              !invoice ||
                              loadingGroupName ||
                              loadingSocialName ||
                              isLoading
                            }
                          >
                            {isLoading ? "Pesquisando..." : "Pesquisar"}
                          </Button>
                        </Grid>
                      </>
                    )}

                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={isMobile ? 12 : isMobile900 && 6}
                        style={{
                          flexDirection: isMobile ? "column" : "row",
                        }}
                      >
                        <Button
                          style={{
                            width: isMobile ? "100%" : "20vw",
                            marginBottom: isMobile ? "0.75rem" : "0rem",
                            marginTop: isMobile ? "0.75rem" : "0",
                          }}
                          variant="contained"
                          onClick={(e) => {
                            handleAddProduct();
                          }}
                          disabled={
                            !product ||
                            !quantity ||
                            !selectedReason ||
                            (defectByReason?.length > 0 && !selectedDefect) ||
                            loadingGroupName ||
                            loadingSocialName
                          }
                        >
                          Adicionar
                        </Button>
                        <ClearButton
                          disable={loadingGroupName || loadingSocialName}
                          fullWidth={isMobile}
                          onClick={() => handleClearFilters()}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}

                {groupName && !socialName && (
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{ color: "grey", marginTop: "1rem" }}
                  >
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                      style={{
                        fontSize: "1rem",
                        marginRight: "0.5rem",
                      }}
                    />{" "}
                    É necessário selecionar uma Razão Social / Loja para
                    realizar a pesquisa.
                  </Typography>
                )}

                {returnType === "1" && isValidProduct === false && (
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{ color: "grey", marginTop: "1rem" }}
                  >
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                      style={{
                        fontSize: "1rem",
                        marginRight: "0.5rem",
                      }}
                    />{" "}
                    Produto informado não encontrado.
                  </Typography>
                )}

                {returnType === "1" && isProductAlreadySelected && (
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{ color: "grey", marginTop: "1rem" }}
                  >
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                      style={{
                        fontSize: "1rem",
                        marginRight: "0.5rem",
                      }}
                    />{" "}
                    Produto já selecionado.
                  </Typography>
                )}

                {returnType === "2" && isInvoiceAlreadySelected && (
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{ color: "grey", marginTop: "1rem" }}
                  >
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                      style={{
                        fontSize: "1rem",
                        marginRight: "0.5rem",
                      }}
                    />{" "}
                    Nota fiscal já selecionada.
                  </Typography>
                )}

                {returnType === "2" && isInvoiceValid === false && (
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{ color: "grey", marginTop: "1rem" }}
                  >
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                      style={{
                        fontSize: "1rem",
                        marginRight: "0.5rem",
                      }}
                    />{" "}
                    Nota informado não encontrada.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {showCNPJNotFound && (
          <Card>
            <NotFound title="Sua pesquisa não encontrou nenhum lojista correspondente." />
          </Card>
        )}
        {addedProductsList?.length > 0 && (
          <Grid container>
            <Grid item xs={12}>
              <TableSolicitacaoDevolucao
                setSelectedProduct={setSelectedProduct}
                setToggleFormDialog={setToggleFormDialog}
                products={addedProductsList}
              />
            </Grid>
          </Grid>
        )}
        {selectedProductsList?.length > 0 && (
          <Grid container>
            <Grid item xs={12}>
              <TableSolicitacaoDevolucaoNota
                productList={selectedProductsList}
                setProductList={setSelectedProductsList}
              />
            </Grid>
          </Grid>
        )}
      </Container>

      {Boolean(toggleFormDialog) && (
        <FormSolicitarDevolucaoDialog
          open
          formType={toggleFormDialog}
          onClose={() => setToggleFormDialog(null)}
          selectedProduct={selectedProduct}
          productsList={addedProductsList}
          setProductsList={setAddedProductsList}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
          selectedReasonComplete={selectedReasonComplete}
          setSelectedReasonComplete={setSelectedReasonComplete}
          selectedDefect={selectedDefect}
          setSelectedDefect={setSelectedDefect}
          selectedDefectComplete={selectedDefectComplete}
          setSelectedDefectComplete={setSelectedDefectComplete}
        />
      )}
      {openDialog && returnType === "1" && (
        <ChooseProductDialog
          open
          onClose={() => setOpenDialog(false)}
          productsList={productsList}
          setSelectedProduct={setChoosedProduct}
          totalPages={totalPages}
          setPage={setPage}
          isLoading={isLoading}
        />
      )}
      {openDialog && returnType === "2" && (
        <ChooseInvoiceDialog
          open
          onClose={() => {
            setOpenDialog(false);
            setInvoice("");
          }}
          invoice={invoiceSelected}
          selectedProductsList={selectedProductsList}
          setSelectedProductsList={setSelectedProductsList}
        />
      )}

      <Container margin={0} maxWidth={true} style={{ justifyItems: "end" }}>
        <Grid item xs={12} style={{ marginBottom: "3rem" }}>
          <Button
            style={{
              width: isMobile ? "100%" : "15vw",
              marginBottom: isMobile ? "0.75rem" : "0rem",
              marginTop: isMobile ? "0.75rem" : "0",
              height: "fit-content",
              alignSelf: "center",
            }}
            variant="contained"
            onClick={(e) => {
              handleSubmit();
            }}
            disabled={
              (returnType === "1" && addedProductsList?.length < 1) ||
              (returnType === "2" && selectedProductsList?.length < 1) ||
              isLoading ||
              loadingGroupName ||
              loadingSocialName ||
              !cnpj
            }
          >
            Avançar
          </Button>
        </Grid>
      </Container>
    </div>
  );
}
